import { QuestionnaireStatus } from '@/gen/questionnaire/common/v1/questionnaire_status_pb'

import { SmartEvidenceRequestDraftBanner } from './smart-evidence-request-draft-banner'
import { SmartEvidenceRequestOngoingBanner } from './smart-evidence-request-ongoing-banner'
import type { SmartEvidenceRequestBannerProps } from './types'

export const SmartEvidenceRequestBanner = (props: SmartEvidenceRequestBannerProps) => {
  const { smartEvidenceQuestionnaire } = props
  const isOngoing = smartEvidenceQuestionnaire?.status === QuestionnaireStatus.ONGOING
  const isSubmitted = smartEvidenceQuestionnaire?.status === QuestionnaireStatus.SUBMITTED

  if (isOngoing || isSubmitted) {
    return <SmartEvidenceRequestOngoingBanner {...props} />
  }

  return <SmartEvidenceRequestDraftBanner {...props} />
}
